module.exports = __webpack_public_path__ + "static/media/C.a4041c17.jpg";